import { render, staticRenderFns } from "./ScoringProfilesList.vue?vue&type=template&id=7ae1c9ba"
import script from "./ScoringProfilesList.vue?vue&type=script&lang=js"
export * from "./ScoringProfilesList.vue?vue&type=script&lang=js"
import style0 from "./ScoringProfilesList.vue?vue&type=style&index=0&id=7ae1c9ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports